import { WorkPosition } from "../models/workPosition";
import resume from "../data/resume.json";

const getPositions = (): WorkPosition[] => {
  return resume.positions;
};

export { getPositions };
